<template>
  <div relative w-full min-h-lg>
    <ClientOnly>
      <MapZone
        v-if="props.field == 'zone.zone2023.displayName'"
        :location="location"
        v-bind="$attrs"
        @interact="attributionOpen = false"
      />
      <MapFeature
        v-else-if="selectedMap"
        :location="location"
        :source="selectedMap.source"
        :lineLayer="selectedMap.lineLayer"
        :labelLayer="selectedMap.labelLayer"
        :labelField="selectedMap.labelField"
        :featureId="value?.replace(' County', '')"
        :bbox="bbox"
        :filter="filter"
        :attribution="false"
        v-bind="$attrs"
        @interact="attributionOpen = false"
      />
      <MapWrapper
        v-else-if="hasLocation"
        :options="{
          center: [location.longitude, location.latitude],
          zoom: 15,
          style: '/styles/elevation-color.json',
        }"
        :marker="true"
        :attribution="false"
        v-bind="$attrs"
        @interact="attributionOpen = false"
      />
      <div v-else w-full h-lg bg-stone-100 bg-opacity-50></div>
      <template #fallback>
        <div w-full h-lg flex justify-center items-center text-stone-400 text-xl>Loading map&hellip;</div>
      </template>
    </ClientOnly>
    <!-- the maps above only render in the browser, so the attribution is here, to be in the server HTML -->
    <MapAttribution v-model:open="attributionOpen" />
  </div>
</template>
<script setup>
import tiles from "~~/data/tiles.json";
const attributionOpen = ref(true);
const props = defineProps({
  location: {
    type: Object,
  },
  field: {
    type: String,
  },
  value: {
    type: String,
  },
  bbox: {
    type: Array,
  },
  filter: {
    type: Array,
  },
});
const outlines = `pmtiles://https://tiles.whatismyelevation.com/${tiles.censusOutlines}`;
const maps = {
  postCode: {
    labelField: "GEOID20",
    source: {
      type: "vector",
      url: outlines,
      promoteId: "GEOID20",
      id: "zip",
      maxzoom: 10,
    },
    lineLayer: "zip_features",
    labelLayer: "zip_names",
  },
  administrativeArea: {
    labelField: "NAME",
    source: {
      type: "vector",
      url: outlines,
      promoteId: "NAME",
      id: "state",
      maxzoom: 10,
    },
    lineLayer: "state_features",
    labelLayer: "state_names",
  },
  "countySubdivision.county.name": {
    labelField: "NAME",
    source: {
      type: "vector",
      url: outlines,
      promoteId: "NAME",
      id: "county",
      maxzoom: 10,
    },
    lineLayer: "county_features",
    labelLayer: "county_names",
  },
  "countySubdivision.fullName": {
    labelField: "NAME",
    source: {
      type: "vector",
      url: `pmtiles://https://tiles.whatismyelevation.com/${tiles.censusBoundaries}`,
      promoteId: "NAME",
      id: "cousub_features",
      maxzoom: 10,
    },
    lineLayer: "cousub_features",
    labelLayer: "cousub_names",
  },
};
const selectedMap = computed(() => maps[props.field]);

const hasLocation = computed(() => {
  return isNumber(props.location?.latitude) && isNumber(props.location?.longitude);
});
</script>
